import ReviewFixModal from './ReviewFixModal.container';

export default ReviewFixModal;
